import { Search } from 'lucide-react';
import CustomSelect from '../shared/CustomSelect';

export const CompanyFilters = ({
                                   searchTerm,
                                   onSearchChange,
                                   selectedScope,
                                   onScopeChange,
                                   activeFilter,
                                   onActiveFilterChange
                               }) => {
    const businessScopes = [
        { value: 'ALL', label: 'All Scopes' },
        { value: 'INSURANCE', label: 'Insurance' },
        { value: 'INVESTMENTS', label: 'Investments' },
        { value: 'BANKING', label: 'Banking' },
        { value: 'IT', label: 'IT Services' },
        { value: 'HEALTHCARE', label: 'Healthcare' },
        { value: 'RETAIL', label: 'Retail' }
    ];

    const activeOptions = [
        { value: 'ALL', label: 'All Status' },
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' }
    ];

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Search */}
                <div className="relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                        type="text"
                        placeholder="Search companies..."
                        value={searchTerm}
                        onChange={(e) => onSearchChange(e.target.value)}
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                {/* Business Scope Filter */}
                <CustomSelect
                    value={selectedScope}
                    onChange={onScopeChange}
                    options={businessScopes}
                    placeholder="All Scopes"
                />

                {/* Active Status Filter */}
                <CustomSelect
                    value={activeFilter}
                    onChange={onActiveFilterChange}
                    options={activeOptions}
                    placeholder="All Status"
                />
            </div>
        </div>
    );
};

export default CompanyFilters;
